<template>
  <div
    class="main"
  >
    <loading
      :show="isLoading"
      label="加载中"
    />
    <div class="main-hd">
      <p class="tit">
        {{ getNewsTypeName(typeID) }}<span> {{ getNewsTypeNameEnglish(typeID) }}</span>
      </p>
      <div class="crumb">
        <span>您的位置：</span>
        <router-link to="/">
          官网首页
        </router-link>
        <span>&gt;</span>
        <span>{{ getNewsTypeName(typeID) }}</span>
      </div>
    </div>
    <div class="main-bd">
      <div class="c1">
        <a
          :class="typeID===0?'nav current':'nav'"
          href="javascript:void(0)"
          @click="GoNews(0)"
        >最新</a>
        <a
          :class="typeID===1?'nav current':'nav'"
          href="javascript:void(0)"
          @click="GoNews(1)"
        >新闻</a>
        <a
          :class="typeID===2?'nav current':'nav'"
          href="javascript:void(0)"
          @click="GoNews(2)"
        >公告</a>
        <a
          :class="typeID===3?'nav current':'nav'"
          href="javascript:void(0)"
          @click="GoNews(3)"
        >活动</a>
      </div>
      <div class="c2">
        <ul
          class="articles"
        >
          <li
            class="item"
            v-for="(item,index) in page_arrs"
            :key="index"
          >
            <span class="tag">【{{ getNewsTypeShortName(item.typeID) }}】</span>
            <a
              href="javascript:void(0)"
              class="con"
              @click="GoNewsContent(item.id,typeID)"
            >
              {{ item.title }}
            </a>
            <span class="date">{{ item.createTime | dateformat('MM/DD') }}</span>
          </li>
        </ul>
        <div class="pagination">
          <ul
            v-for="n in page_count"
            :key="n"
          >
            <li :class="n===pageIndex?'page selected':'page'">
              <a
                href="javascript:void(0)"
                :class="n===pageIndex?'current':''"
                @click="pageIndex = n"
              >{{ n }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import { getNewsTypeName, getNewsTypeNameEnglish, getNewsTypeShortName } from '../../utils/utils'

export default {
  components: {
    loading
  },
  created () {
    // console.log('mounted:' + this.typeID)
    // this.typeID = this.$route.query.typeID || 0
    // console.log('created begin:' + this.isLoading)
    this.getList()
    // console.log('created end:' + this.isLoading)
  },
  watch: {
    '$route' (to, from) {
    // 刷新参数放到这里里面去触发就可以刷新相同界面了
      this.typeID = parseInt(this.$route.query.typeID) || 0
      // console.log('route begin:' + this.isLoading)
      this.getList()
      // console.log('route end:' + this.isLoading)
      // console.log('route:' + this.typeID)
    }
  },
  data () {
    return {
      typeID: parseInt(this.$route.query.typeID) || 0,
      newsList: [],
      isLoading: true,
      pageIndex: 1,
      pageCount: 1,
      pageSize: 15
    }
  },
  computed: {
    page_arrs () {
      const { pageIndex, pageSize } = this
      return this.newsList.slice((pageIndex - 1) * pageSize, pageIndex * pageSize)
    },
    page_count () {
      return Math.ceil(this.newsList.length / this.pageSize)
    }
  },
  methods: {
    getList () {
      this.isLoading = true
      this.$api.getNewsList(this.typeID).then(res => {
        this.newsList = res.data.list
      })
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    },
    GoNews (typeID) {
      this.$router.push({
        path: '/news/list',
        query: {
          typeID: typeID
        }
      })
    },
    GoNewsContent (newsID, typeID) {
      this.$router.push({
        path: '/news/view',
        query: {
          id: newsID,
          tid: typeID
        }
      })
    },
    getNewsTypeName,
    getNewsTypeNameEnglish,
    getNewsTypeShortName
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news/main.vue